<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="step == 1 ? '860px' : '460px'"
    @closed="closed"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div class="aliform" v-html="aliform" v-show="false"></div>
    <div>
      <div class="content_top">余额充值</div>
      <div class="content_box" v-show="step == 1">
        <div class="tittle">选择优惠</div>
        <div class="item_box">
          <div
            class="item"
            @click="itemclick(item)"
            :class="{ active: form.packageId == item.packageId }"
            v-for="item in list"
            :key="item.packageId"
          >
            <div class="item_top">
              <span style="font-size: 16px; margin-right: 6px">¥</span>
              <span>{{ item.coins | priceFormat }}</span>
            </div>
            <div class="item_bottom">
              <span>限时优惠价</span>
              ：{{ item.price | priceFormat }}元
            </div>
            <div class="zhe">
              {{ ((item.price / item.coins) * 10) | priceFormat(1) }}折
            </div>
          </div>
        </div>
        <div class="tittle">自定义充值</div>
        <el-form size="mini" :model="form" ref="form">
          <el-row :gutter="30">
            <el-col :span="24">
              <el-form-item prop="item">
                <div class="asd">
                  <span style="margin-right: 10px">充值金额</span>
                  <el-input-number
                    :controls="false"
                    v-model="form.coins"
                    @focus="clear"
                    :disabled="form.packageId > 0"
                    placeholder="充值金额"
                    type="number"
                    style="width: 140px"
                    :min="100"
                  ></el-input-number>
                  <span style="font-size: 14px; color: #999"
                    >（最低充值金额为100元，该余额无法提现。）</span
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div v-show="step === 2">
        <div class="step2">
          <div class="item_top">
            <span style="font-size: 16px; margin-right: 6px">¥</span>
            <span>{{ form.coins }}</span>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-show="step == 1">
      <el-button @click="close" size="mini">取 消</el-button>
      <el-button type="primary" @click="submit" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      form: {
        packageId: null,
        coins: 0,
      },
      step: 1,
      aliform: "",
    };
  },
  mounted() {},
  methods: {
    async show() {
      await this.postRechargePackage();
      this.dialogVisible = true;
    },
    async submit() {
      const { status, data } = await this.postRecharge();
      this.aliform = data;
      console.log(data);
      this.$nextTick(() => {
        document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
      });

      if (status == 2) {
        this.step = 2;
      }
      // this.$refs.form.validate(valid => {
      //     if (valid) {
      //         this.onsubmit()
      //     } else {
      //         return false
      //     }
      // })
    },
    close() {
      this.dialogVisible = false;
    },
    clear() {
      this.form = {
        packageId: null,
        coins: 0,
      };
    },
    closed() {
      this.clear();
    },
    // 获取充值套餐列表
    async postRechargePackage() {
      const { data } = await this.$api.postRechargePackage();
      this.list = data;
      return new Promise((suc, err) => {
        suc(data);
      });
    },
    //账号充值
    async postRecharge() {
      const returnUrl = `${window.location.host}${window.location.pathname}`;
      const res = await this.$api.postRecharge({ ...this.form, returnUrl });
      return new Promise((suc, err) => {
        suc(res);
      });
    },
    async ondelete() {
      const { status, info } = await this.$api.deleteArchiveDir({ dirId: this.dirId });
      if (status === 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.$emit("success");
        this.dialogVisible = false;
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
    itemclick({ packageId }) {
      if (this.form.packageId == packageId) {
        this.clear();
      } else {
        this.form.packageId = packageId;
        this.form.coins = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-dialog {
  border-radius: 10px;
  overflow: hidden;

  &__body {
    padding: 0;
  }

  &__header {
    padding: 0;
  }
}

.content_top {
  line-height: 60px;
  background: #f3f6f8;
  text-align: center;
  color: #262626;
  font-family: "Noto Sans SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.content_box {
  padding: 0 20px;

  .tittle {
    font-family: "Noto Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px;
  }

  .item_box {
    display: flex;
    flex-wrap: wrap;

    .item:nth-child(3n - 1) {
      margin: 0 22px;
    }

    .item {
      cursor: pointer;
      width: calc((100% - (22px * 2)) / 3);
      display: flex;
      align-items: center;
      height: 135px;
      border-radius: 4px;
      border: 1.5px solid #eee;
      background: linear-gradient(90deg, #fff 0%, #f8f8f8 100%);
      flex-direction: column;
      justify-content: center;
      margin-bottom: 22px;
      position: relative;

      &_top {
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #262626;
      }

      &_bottom {
        color: #999;
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        // text-decoration: line-through;
        //    background: linear-gradient(111deg, #F07B41 2.95%, #EB412A 100%);
        span {
          background: linear-gradient(111deg, #f07b41 2.95%, #eb412a 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .zhe {
        width: 60px;
        height: 20px;
        background: linear-gradient(111deg, #f07b41 2.95%, #eb412a 100%);
        position: absolute;
        right: 0;
        top: 0;
        color: #fff;
        font-family: "Noto Sans SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        border-radius: 0 4px 0 4px;
      }
    }

    .item:nth-child(-3) {
      margin-bottom: 0;
    }

    .active {
      border: 2px solid #1f5aec;

      .item_top {
        background: linear-gradient(180deg, #0062ff 0%, #003b99 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .zhe {
        right: -1px;
        top: -1px;
      }
    }
  }

  .asd {
    display: flex;
  }
}
</style>
